import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CdkDragPlaceholder } from "@angular/cdk/drag-drop";
import { SAMPLE_CHAT_QUESTIONS } from '../../data/samples';

@Component({
  selector: 'rappider-onboarding-widget',
  standalone: true,
  imports: [
    CommonModule,
    NzCardModule,
    NzButtonModule,
    NzToolTipModule,
    NzAlertModule,
    CdkDragPlaceholder
  ],
  templateUrl: './onboarding-widget.component.html',
  styleUrls: ['./onboarding-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingWidgetComponent {
  @Input() isDemoProject: boolean | undefined; // This should be set based on the actual project context
  @Input() hasOwnProject? = false;
  @Input() hasAskedSampleQuestion? = false;
  @Input() tour?: string;
  @Output() demoQuestionAsked = new EventEmitter<string>();
  @Output() createProjectOnDemoClicked = new EventEmitter<string>();
  @Output() exploreClicked = new EventEmitter();

  sampleQuestions = SAMPLE_CHAT_QUESTIONS;

  lastSampleQuestionAsked: string | undefined;

  demoAlertCollapsed = false;

  onDemoAskQuestionsButtonClicked() {
    // find a random number and get from sampleQuestions, if the last asked question is the same, find another one
    const filteredQuestions = this.lastSampleQuestionAsked ?
      this.sampleQuestions?.filter(q => q !== this.lastSampleQuestionAsked) : this.sampleQuestions;
    const randomIndex = Math.floor(Math.random() * filteredQuestions.length);
    const randomQuestion = filteredQuestions[randomIndex];
    this.lastSampleQuestionAsked = randomQuestion;
    this.demoQuestionAsked.emit(randomQuestion);
  }

  onExploreClicked() {
    this.exploreClicked.emit();
  }

  onDemoCreateProjectButtonClicked() {
    this.createProjectOnDemoClicked.emit(new Date().toISOString());
  }

  onDemoWorkspaceAlertToggle(event: boolean) {
    // Handle the alert toggle event
    this.demoAlertCollapsed = !this.demoAlertCollapsed;
  }

}
